module.exports = __webpack_public_path__ + "img/promo_maslo.b9f3ab45.png";